import { atom } from "recoil";

export const SelectedCalanderDateState = atom<Date | null>({
  key: "selectedCalanderDateState",
  default: null,
});
